module.exports = __webpack_public_path__ + "img/lotery-rewards-3.416fec24.jpg";